import Image from "next/image";
import Link from "next/link";
import React from "react";

const FeaturesGrid = ({ features }) => {
  return (
    <div className="container">
      <div className="lg:flex lg:space-x-12">
        <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden !ml-0">
          <Image
            width={1519}
            height={935}
            src="/images/gradient.jpg"
            alt="gradient"
            className="h-full w-full object-cover"
          />
        </picture>
        <picture className="pointer-events-none absolute inset-0 -z-10 hidden dark:block !ml-0">
          <Image
            width={1519}
            height={935}
            src="/images/gradient_dark.jpg"
            alt="gradient dark"
            className="h-full w-full object-cover"
          />
        </picture>
      </div>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 md:gap-[1.875rem]">
        {features.map((item) => {
          const {
            id,
            image,
            title,
            description,
            icon,
            bgColor,
            iconColor,
            buttonText,
            link,
          } = item;
          return (
            <div
              key={id}
              className="dark:bg-jacarta-700 dark:border-jacarta-600 border-jacarta-100 rounded-2.5xl mb-8 border bg-white p-8 text-center transition-shadow hover:shadow-lg"
            >
              {/* className="dark:bg-jacarta-700 dark:border-jacarta-600 border-jacarta-100 rounded-2.5xl mb-8 border bg-white p-8 text-center transition-shadow hover:shadow-lg" */}
              {/* <Image
                width={86}
                height={86}
                src={image}
                className="dark:border-jacarta-600 dark:bg-jacarta-700 border-jacarta-100 mx-auto mb-7 -mt-[3.5rem] h-[5.5rem] w-[5.5rem] rounded-full border bg-white"
                alt="wallet"
              /> */}
              <div className="flex items-center justify-center">
                <div
                  className={`rounded-full w-20 h-20 m-4 flex items-center justify-center ${bgColor}`}
                >
                  <Image
                    width={86}
                    height={86}
                    src={image}
                    className=",-4"
                    alt="wallet"
                  />
                </div>
              </div>
              <h3 className="mb-2 mt-1 block font-display text-xl font-medium group-hover:text-accent dark:text-white uppercase">
                {title}
              </h3>
              <p className="text-lg dark:text-jacarta-300">{description}</p>
              <Link
                href={link ? link : "#"}
                target={link ? "_blank" : "_self"}
                className={`inline-block rounded-full py-3 px-8 text-center font-semibold shadow-accent-volume transition-all uppercase mt-[15px] ${
                  link
                    ? "bg-accent text-white hover:bg-accent-dark"
                    : "bg-gray-500 text-gray-300 cursor-not-allowed"
                }`}
              >
                {buttonText}
              </Link>
            </div>
          );
        })}
        
      </div>
    </div>
  );
};

export default FeaturesGrid;
